"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultDropShadowColor = exports.TertiaryButtonTheme = exports.SecondaryButtonTheme = exports.PrimaryButtonTheme = exports.DestructiveButtonTheme = exports.DangerTertiaryButtonTheme = exports.DangerButtonTheme = void 0;
var _colors = require("../../colors");
var lightShadowOpacity = 0.13;
var darkShadowOpacity = 0.3;
var defaultDropShadowColor = exports.defaultDropShadowColor = '#15372C26';
var PrimaryButtonTheme = exports.PrimaryButtonTheme = {
  name: 'primary',
  loadingSpinnerFlavor: 'pale',
  "default": {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_600,
    backgroundColor: _colors.FullPalette.IRIS_600,
    iconColor: _colors.FullPalette.WHITE,
    dropShadowColor: defaultDropShadowColor
  },
  hover: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_700,
    backgroundColor: _colors.FullPalette.IRIS_700,
    dropShadowOpacity: darkShadowOpacity,
    iconColor: _colors.FullPalette.WHITE
  },
  active: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_700,
    backgroundColor: _colors.FullPalette.IRIS_700,
    iconColor: _colors.FullPalette.WHITE
  },
  lg: {
    borderRadius: 12,
    height: 40,
    fontSize: 16,
    lineHeight: 24,
    iconSize: 'md',
    padding: {
      iconOffset: 8,
      vertical: 6,
      horizontal: 24
    }
  },
  md: {
    borderRadius: 8,
    height: 32,
    fontSize: 14,
    lineHeight: 20,
    iconSize: 'sm',
    padding: {
      iconOffset: 4,
      vertical: 4,
      horizontal: 16
    }
  },
  sm: {
    borderRadius: 4,
    height: 24,
    fontSize: 12,
    lineHeight: 16,
    iconSize: 'xs',
    padding: {
      iconOffset: 2,
      vertical: 2,
      horizontal: 12
    }
  }
};
var SecondaryButtonTheme = exports.SecondaryButtonTheme = {
  name: 'secondary',
  loadingSpinnerFlavor: 'green',
  "default": {
    color: _colors.FullPalette.GREEN_700,
    borderColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.GREEN_700,
    dropShadowColor: defaultDropShadowColor
  },
  hover: {
    color: _colors.FullPalette.EVERGREEN_700,
    borderColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.WHITE,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: _colors.FullPalette.EVERGREEN_700
  },
  active: {
    color: _colors.FullPalette.EVERGREEN_700,
    borderColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.GREY_E25,
    iconColor: _colors.FullPalette.EVERGREEN_700
  },
  lg: PrimaryButtonTheme.lg,
  md: PrimaryButtonTheme.md,
  sm: PrimaryButtonTheme.sm
};
var DangerButtonTheme = exports.DangerButtonTheme = {
  name: 'danger',
  loadingSpinnerFlavor: 'poppy',
  "default": {
    color: _colors.FullPalette.POPPY_600,
    borderColor: _colors.FullPalette.POPPY_600,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.POPPY_600,
    dropShadowColor: defaultDropShadowColor
  },
  hover: {
    color: _colors.FullPalette.POPPY_700,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.WHITE,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: _colors.FullPalette.POPPY_700
  },
  active: {
    color: _colors.FullPalette.POPPY_700,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.GREY_E25,
    iconColor: _colors.FullPalette.POPPY_700
  },
  lg: PrimaryButtonTheme.lg,
  md: PrimaryButtonTheme.md,
  sm: PrimaryButtonTheme.sm
};
var DestructiveButtonTheme = exports.DestructiveButtonTheme = {
  name: 'destructive',
  loadingSpinnerFlavor: 'pale',
  "default": {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_600,
    backgroundColor: _colors.FullPalette.POPPY_600,
    iconColor: _colors.FullPalette.WHITE,
    dropShadowColor: defaultDropShadowColor
  },
  hover: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.POPPY_700,
    dropShadowOpacity: darkShadowOpacity,
    iconColor: _colors.FullPalette.WHITE
  },
  active: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.POPPY_700,
    iconColor: _colors.FullPalette.WHITE
  },
  lg: PrimaryButtonTheme.lg,
  md: PrimaryButtonTheme.md,
  sm: PrimaryButtonTheme.sm
};
var TertiaryButtonTheme = exports.TertiaryButtonTheme = {
  name: 'tertiary',
  "default": {
    color: _colors.FullPalette.GREEN_700
  },
  hover: {
    color: _colors.FullPalette.EVERGREEN_700
  }
};
var DangerTertiaryButtonTheme = exports.DangerTertiaryButtonTheme = {
  name: 'dangerTertiary',
  "default": {
    color: _colors.FullPalette.POPPY_600
  },
  hover: {
    color: _colors.FullPalette.POPPY_500
  }
};